import React, { useState, forwardRef, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import { CREDIT_API_URL, ASSETS_URL } from "../../constants";
import useUtmStore from '../../store/useUtmStore';
import getClientInfo from '../../utility/getClientInfo';
const PaymentFormSection = forwardRef(({ selectedValue }, ref) => {
    const {t} =useTranslation(['invoicepage','paymentpage','homepage']);
    const utm = useUtmStore(state => state.utm || {});
    const { browserName, deviceType, userAgent } = getClientInfo();
    const [formData, setFormData] = useState({
        productType: "Payment",
        mobile: "",
        name:"",
        businessName:"",
        isConsentAccepted:true
    });

    const [isMobileValid, setIsMobileValid] = useState(false);
    // Handle input changes
    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
        ...formData,
        [name]: name === "mobile" ? parseInt(value, 10) ||name === "name" || name === "businessName"|| "" : value,
    });

    if (name === "mobile") {
        setIsMobileValid(/^\d{10}$/.test(value)); // Update validity based on regex
    }
    };
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission
        const controller = new AbortController();
        const messageDiv = document.getElementById("frm-error");
        const timeout = setTimeout(() => controller.abort(), 6000);
        try {
            const payload = {
                ...formData,
                utmCampaign: utm.utmCampaign || "GrowBizh",
                utmSource: utm.utmSource || null,
                utmMedium: utm.utmMedium || null,
                browserName: browserName || null,
                deviceType: deviceType || null,
            };
            const response = await fetch(""+CREDIT_API_URL+"create-lead", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            clearTimeout(timeout);
            if(response.status !== 200){
                const v_result = await response.json();
                throw new Error(v_result.message);
            }
            // Display success message in the HTML
            messageDiv.style.color = "green";
            messageDiv.textContent = "Thanks!! We will get back to you soon.";
            messageDiv.style.display = "block";
        } catch (error) {
            console.error("Error submitting form:", error);
            messageDiv.style.color = "red";
            messageDiv.textContent = error.message;
            messageDiv.style.display = "block";
        }
        setTimeout(() => messageDiv.style.display = "none", 3000);
    };
    useEffect(() => {
        if (selectedValue) {
          setFormData((prevData) => ({
            ...prevData,
            productType: selectedValue,
          }));
        }
    }, [selectedValue]);
    return (
        <section className='section-container invoice-form-section-mobile' ref={ref}>
            <div className="invoice-form-section-container">
                <div className="left-invoice-form-section-container">
                    <div className="left-invoice-form-section-container-title">{t('left-payment-form-section.line1',{ ns: 'paymentpage' })}</div>
                    <p className="left-invoice-form-section-container-content mt-1">
                    {t('left-payment-form-section.line2',{ ns: 'paymentpage' })}
                    </p>
                    <div className='left-invoice-form-section-container-img'>
                        <img src='/images/aero-group.png' alt='aeroplane'/>
                    </div>
                    
                </div>
                <div className="right-invoice-form-section-container">
                <div className="form-section">
                        <form className="form-horizontal" onSubmit={handleSubmit}>
                            <div className="form-group mt-1">
                                <h3>{t('form-title',{ns:'homepage'})} </h3>
                            </div>
                            <div className="form-group mt-1 input-group">
                                <img src={`${ASSETS_URL}images/mobile.svg`} alt="" />
                                <input type="text" className={`form-control ${isMobileValid ? 'valid' : ''} input-field`} required placeholder="" name="mobile" value={formData.mobile}
                                onChange={handleChange} id="contact" autoComplete="off"/>
                                <label htmlFor="contact" className="placeholder">{t('invoice-form-section.placeholder1')}</label>
                                {isMobileValid && <img src='/images/form-mobile-tick-icon-desktop.svg' alt='' className='valid-icon'/>}
                            </div>
                            <div className="form-group mt-1 input-group">
                                <img src="/images/form-name-icon.svg" alt="" />
                                <input type="text" className="form-control input-field"  placeholder="" name="name" value={formData.name}
                                onChange={handleChange} id='name' autoComplete="off"/>
                                <label htmlFor="name" className="placeholder">{t('invoice-form-section.placeholder2')}</label>
                            </div>
                            <div className="form-group mt-1 input-group">
                                <img src="images/form-business-icon.svg"alt="" />
                                <input type="text" className="form-control input-field" placeholder="" name="businessName" value={formData.businessName}
                                    onChange={handleChange} autoComplete="off" id="business-name"/>
                                <label htmlFor="business-name" className="placeholder">{t('invoice-form-section.placeholder3')}</label>
                            </div>
                            <div className="form-group">
                                <h4>{t('form-description',{ns:'invoicepage'})}</h4>
                            </div>
                            <div className="form-group mt-1" id='frm-error'></div>
                            <div className="form-group mt-1 mb-1">
                                <button className="btn-small-mobile btn-small btn-primary" disabled={!isMobileValid}>{t('invoice-form-section-button')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
})

export default PaymentFormSection;